export enum ProcessStatus {
  OPEN_ID = '595c20500190000000000001',
  FINISHED_ID = '595c20500190000000000002',
  ABORTED_ID = '595c20500190000000000003',
  ERROR_ID = '595c20500190000000000004',
}
